import React from 'react'

import { makeStyles } from '@mui/styles'
import { ModalBig } from '@/modules/base/components/modal/index'
import CsatContent from '@/modules/base/components/csat-modal/csat-content/csat-content'

const useStyles = makeStyles(() => {
  return {
    container: {
      minWidth: 1050,
      height: 660,
      minHeight: 660,
      padding: 0,
    },
  }
})

interface CsatModalProps {
  open: boolean;
  feature: string;
  openAfterCount?: number;
  onClose: () => void;
}

const CsatModal: React.FC<CsatModalProps> = (props) => {
  const {
    open,
    feature,
    openAfterCount,
    onClose,
  } = props
  const classes = useStyles()

  return (
    <ModalBig
      open={open}
      className={classes.container}
      showCloseIcon={false}
      maxWidth={false}>
      <CsatContent
        showCloseIcon
        feature={feature}
        openAfterCount={openAfterCount}
        onAbort={onClose}
      />
    </ModalBig>
  )
}

export default CsatModal
